import { isNil } from 'lodash'

import { system } from '@eastcoal/common/config/system'
import { pick } from '@eastcoal/common/utils/object'

import { ApplicationType } from '@eastcoal/shared/enums/ApplicationType'

import { useAuthStore } from '../useStore'

/**
 * 是否属于当前用户的数据
 */
export const useBelongOwnData = (dataOwnerProfileId?: string) => {
  const { profileId, administrator, superAdministrator } = useAuthStore(state =>
    pick(state, ['profileId', 'administrator', 'superAdministrator'])
  )

  if (
    (system.env.appType !== ApplicationType.OPERATION && administrator) ||
    (system.env.appType === ApplicationType.OPERATION && superAdministrator)
  ) {
    return true
  }

  return isNil(dataOwnerProfileId) ? true : dataOwnerProfileId === profileId
}
